// extracted by mini-css-extract-plugin
export default {"container":"SplashScreen_container__Wuoan","logo":"SplashScreen_logo__FB54i"};